/*
 * IRIS Interactive
 *
 * NOTICE OF LICENSE
 *
 * This source file is no subject to a specific license
 * but it belongs to the company IRIS Interactive.
 * You can contact IRIS Interactive at the following
 * address: contact@iris-interactive.fr
 *
 * @author      Camille CHAREL
 * @date        28/02/2020 11:33
 * @copyright   Copyright (c) 2002-2020 IRIS Interactive, Inc. (https://www.iris-interactive.fr)
 * @package     SampledefaultTheme
 */

import 'slick-carousel/slick/slick.min';
import Modernizr from 'modernizr';

export default class Slider {
    
    constructor()
    {
        Slider.initializeRelatedPost();
        Slider.initializeHomeSlider();
        Slider.initializeSliderAuthors();
        Slider.initializeHighlight();
        Slider.initializeAffinitySlider();
        Slider.initializeMapSlider();
        Slider.initSliderScrollytelling();
    }
    
    static initializeRelatedPost()
    {
        
        let $sliders = $( '.relatedpostList' );
        
        $sliders.each( function () {
            let id_slider = $( this ).attr( 'id' ),
                $items    = $( '#' + id_slider + ' .entityItem' ),
                $slider   = $( '#' + id_slider );
            
            if ( $items.length > 4
                 || ($items.length > 3 && window.matchMedia( "(max-width: 1000px) AND (min-width: 651px)" ).matches)
                 || ($items.length > 2 && window.matchMedia( "(max-width: 650px) AND (min-width: 321px)" ).matches)
                 || ($items.length > 1 && window.matchMedia( "(max-width: 320px)" ).matches)
            
            ) {
                let settings = {
                    slidesToShow: 4,
                    slidesToScroll: 1,
                    arrows: true,
                    dots: false,
                    infinite: false,
                    variableWidth: true,
                    responsive: [
                        {
                            breakpoint: 1000,
                            settings: {
                                slidesToShow: 3,
                                slidesToScroll: 2,
                                arrows: false,
                            }
                        },
                        {
                            breakpoint: 650,
                            settings: {
                                slidesToShow: 2,
                                slidesToScroll: 1,
                                arrows: false,
                            }
                        },
                    ]
                };
                $slider.slick( settings );
            }
        } );
    }
    
    static initializeHomeSlider()
    {
        //Slider home
        let $slider    = $( '.sliderList' ),
            sliderItem = '.sliderItemPhoto';
        
        if ( $( sliderItem ).length > 0 ) {
            $slider.slick(
                {
                    slide: sliderItem,
                    infinite: false,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    autoplay: true,
                    autoplaySpeed: 4000,
                    speed: 1000,
                    arrows: true,
                    dots: false,
                    fade: true,
                    cssEase: 'linear',
                    responsive: [
                        {
                            breakpoint: 1000,
                            settings: {
                                arrows: false,
                            }
                        },
                    ]
                } );
        }
        
    }
    
    static initializeHighlight()
    {
        //Slider home
        let $slider    = $( '.strateHighlightSlider' ),
            sliderItem = '.highlightItem';
        
        if ( $( sliderItem ).length > 1 ) {
            $slider.slick(
                {
                    slide: sliderItem,
                    infinite: false,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: true,
                    dots: false,
                    variableWidth: true,
                    prevArrow: $( "[data-slide-arrow ='prev']" ),
                    nextArrow: $( "[data-slide-arrow ='next']" ),
                    speed: 1200,
                    responsive: [
                        {
                            breakpoint: 1000,
                            settings: {
                                arrows: false,
                            }
                        },
                    ]
                } );
        }
        
    }
    
    static initializeSliderAuthors()
    {
        let $slider = $( '.authorList' ),
            $items  = $( '.authorBloc' );
        
        if ( $items.length > 1 ) {
            let settings = {
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: true,
                dots: false,
                infinite: false,
            };
            $slider.slick( settings );
        }
    }
    
    static initializeAffinitySlider()
    {
        const $slider = $( '.affinitySlider' );
        $slider.slick(
            {
                slidesToShow: 3,
                slidesToScroll: 3,
                variableWidth: true,
                arrows: true,
                dots: false,
                infinite: false,
                responsive: [
                    {
                        breakpoint: 1000,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 2,
                            initialSlide: 0,
                            arrows: false,
                        }
                    },
                    {
                        breakpoint: 650,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1,
                            initialSlide: 0,
                            arrows: false,
                        }
                    },
                ]
            }
        );
    }
    
    static initializeMapSlider()
    {
        const $slider = $( '.strateMapContentPreviewList' );
        
        if ( (window.matchMedia( "(max-width: 1000px)" ).matches) ) {
            $slider.slick(
                {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    variableWidth: true,
                    arrows: false,
                    dots: false,
                    infinite: false
                }
            );
        }
    }
    
    static initSliderScrollytelling()
    {
        const slider = $( '.strateScrollytellingList' );
    
        slider.slick(
            {
                slidesToShow: 4,
                slidesToScroll: 1,
                variableWidth: true,
                arrows: true,
                dots: false,
                infinite: false,
                responsive: [
                    {
                        breakpoint: 1280,
                        settings: {
                            slidesToShow: 3,
                            initialSlide: 0,
                        }
                    },
                    {
                        breakpoint: 1000,
                        settings: {
                            arrows: false,
                        }
                    },
                    {
                        breakpoint: 650,
                        settings: {
                            slidesToShow: 2,
                            initialSlide: 0,
                            arrows: false,
                        }
                    },
                ]
            }
        );
    }
}
